export default __webpack_public_path__ + "static/tracey-a62564e5ebba29bd2bc2d6c40bcb7ed1.svg";